import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFilters } from '@haus-storefront-react/filters'
import { AriaLiveRegion, Button } from '@components'
import { DefaultFilterUrlStrategy } from '@haus-storefront-react/strategies'

interface ClearFiltersProps {
  productListIdentifier: string
  configStyles?: {
    buttonVariant?: {
      variant?: string
    }
  }
}

export default function ClearFiltersComponent({
  productListIdentifier,
  configStyles,
}: ClearFiltersProps) {
  const { t } = useTranslation()
  const [filterAnnouncement, setFilterAnnouncement] = useState('')

  const { hasActiveFilters, clearFilters } = useFilters({
    productListIdentifier,
    strategies: {
      filtersStoreStrategy: new DefaultFilterUrlStrategy(),
    },
  })
  const buttonVariant = configStyles?.buttonVariant?.variant ?? 'primary'

  const handleClearFilters = () => {
    clearFilters()
    setFilterAnnouncement(t('a11y.filter.ariaLive.allFiltersCleared'))
  }

  useEffect(() => {
    if (!filterAnnouncement) return
    const id = window.setTimeout(() => setFilterAnnouncement(''), 1000)
    return () => window.clearTimeout(id)
  }, [filterAnnouncement])

  return (
    <>
      <AriaLiveRegion message={filterAnnouncement} />
      {hasActiveFilters && (
        <Button
          aria-label={t('a11y.filter.aria.clearFilters')}
          onClick={handleClearFilters}
          variant={buttonVariant}
        >
          {t('a11y.filter.aria.clearFilters')}
        </Button>
      )}
    </>
  )
}
